module.exports = __webpack_public_path__ + "static/CannabisEssentials_Logo-3468eac94961253256ae1f53af6f4fbc.svg";